import { Outlet, useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { FloatingCart } from "./FloatingCart";

// Defer non-critical, below-the-fold widgets to shrink the initial JS bundle.
const LiveChat = lazy(() => import("./LiveChat"));
const ConsentBanner = lazy(() =>
  import("./ConsentBanner").then((m) => ({ default: m.ConsentBanner }))
);

export function Layout() {
  const { pathname } = useLocation();
  const isLockIn = pathname === "/lock-in";
  const isContentStudio = pathname === "/content-studio";

  return (
    <div className="min-h-screen bg-background font-medical">
      {!isContentStudio && <Navigation />}
      <main>
        <Outlet />
      </main>
      {!isContentStudio && <Footer />}
      <Suspense fallback={null}>
        {!isLockIn && !isContentStudio && <LiveChat />}
        {!isContentStudio && <ConsentBanner />}
      </Suspense>
      {!isContentStudio && pathname !== "/checkout" && <FloatingCart raisedOnMobile={isLockIn} compactOnProduct={pathname === "/products/brain-charge"} />}
    </div>
  );
}